import { render, staticRenderFns } from "./form-tag.vue?vue&type=template&id=2ce9ff38"
import script from "./form-tag.vue?vue&type=script&lang=js"
export * from "./form-tag.vue?vue&type=script&lang=js"
import style0 from "./form-tag.vue?vue&type=style&index=0&id=2ce9ff38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports